import { IonCol, IonRow } from "@ionic/react";
import { Chart as ChartJS } from "chart.js/auto";
import { FC, useReducer } from "react";
import { ChartJSOrUndefined } from "react-chartjs-2/dist/types";


export const energyUnits = ["kWh", "kvarh", "kvarh"];
export const powerUnits = ["kW", "kvar", "kvar"];

const LegendItem : FC<{
  chart : ChartJS<"bar">,
  index : number,
  v : { label?: string, backgroundColor?: string },
  power ?: boolean,
	noClick?: boolean,
}> = (props) => {
  const [, update] = useReducer((v : number) => v + 1, 0);

  return <p onClick={() => {
		if (props.noClick) return;
    props.chart?.setDatasetVisibility(props.index, !props.chart.isDatasetVisible(props.index));
    props.chart?.update();
    update();
  }} style={{cursor: "pointer"}}>
    <span style={{
      backgroundColor: props.chart?.isDatasetVisible(props.index) ? props.v.backgroundColor?.toString() : undefined,
      borderColor: props.v.backgroundColor?.toString(),
      borderWidth: "2px",
      borderStyle: "solid",
      display: "inline-block",
      width: "1em",
      height: "1em",
      marginRight: "5px",
    }} />
    {props.v.label} [{(props.power ? powerUnits : energyUnits)[props.index % 3]}]
  </p>
}

export const EnergyLegend : FC <{
  chart : ChartJSOrUndefined<"bar">,
  power ?: boolean,
	noClick?: boolean,
	data: { label?: string, backgroundColor?: any }[],
}> = (props) => {
  if (!props.chart?.options.plugins?.legend) return <></>;

  return <IonRow style={{width: "100%", fontSize: "small"}}>
    <IonCol>
      {[0, 1, 2].map(i => <LegendItem key={i} chart={props.chart!} index={i} v={props.data[i]} power={props.power} noClick={props.noClick} />)}
    </IonCol>
    <IonCol>
      {[3, 4, 5].map(i => <LegendItem key={i} chart={props.chart!} index={i} v={props.data[i]} power={props.power} noClick={props.noClick} />)}
    </IonCol>
  </IonRow>
}

